import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {DashboardComponent} from './dashboard/dashboard.component';
import { AuthGuard } from './_helpers';
import { LoginComponent } from './account/login.component';
import { NewDashboardComponent } from './new-dashboard/new-dashboard.component';

const accountModule = () => import('./account/account.module').then(x => x.AccountModule);
const usersModule = () => import('./UserFranchiseMaster/user-master.module').then(x => x.UserMasterModule);
const reportsModule = () => import('./reports/reports.module').then(x=> x.ReportsModule);
const mastersModule = () => import('./master/master.module').then(x=>x.MasterModule);

const routes: Routes = [
  { path: '', component: DashboardComponent, canActivate:[AuthGuard]},
  // { path: '', component: NewDashboardComponent, canActivate:[AuthGuard]},

  // {path :'users', loadChildren:usersModule, canActivate:[AuthGuard]},
  {path : 'reports', loadChildren:reportsModule, canActivate:[AuthGuard]},
  {path: 'masters', loadChildren:mastersModule, canActivate:[AuthGuard]},
  {path: 'users', loadChildren:usersModule, canActivate:[AuthGuard]},
  {path: 'account', loadChildren:accountModule},
  {path:'**',redirectTo:''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
